import CryptoJS from "crypto-js";
import forge from "node-forge";
import CONFIG from "../config";

export const encryptPayload = (payload) => {
  try {
    const symmetricKey = CryptoJS.lib.WordArray.random(32);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      symmetricKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();

    const publicKey = forge.pki.publicKeyFromPem(
      CONFIG.REQUEST_RESPONSE_ENCRYPTION.publicKey
    );
    const symmetricKeyBytes = forge.util.hexToBytes(
      symmetricKey.toString(CryptoJS.enc.Hex)
    );
    const encryptedSymmetricKey = forge.util.encode64(
      publicKey.encrypt(symmetricKeyBytes, "RSA-OAEP")
    );

    return {
      encrypted_data: encryptedData,
      encrypted_symmetric_key: encryptedSymmetricKey,
      iv: iv.toString(CryptoJS.enc.Base64),
    };
  } catch (error) {
    console.error("Encryption failed: ", error);
    throw new Error("Failed to encrypt response");
  }
};
